import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Loading, Modal } from '@carbon/react';

import { hideForm } from 'services/forms';
import { useDeleteDeviceMutation } from 'services/device';
import { showToast } from 'services/toasts';

//TODO: RemoveDevice, RemoveLocation, RemoveElement kann man zusammenführen
const RemoveDeviceModal = ({ device, hideModal }) => {
  const dispatch = useDispatch();
  const [deleteDevice] = useDeleteDeviceMutation();
  const [isLoading, setIsLoading] = useState(false);

  // Resolve the id once at mount time. If the caller opened the modal
  // without a device (or with a malformed object missing model.ID), we
  // log a warning and close the modal instead of letting `device.model.ID`
  // throw inside the submit handler.
  const deviceID = device?.model?.ID;
  const deviceLabel = device?.label || device?.name || `#${deviceID || '?'}`;

  useEffect(() => {
    if (deviceID == null) {
      // eslint-disable-next-line no-console
      console.warn('RemoveDeviceModal opened without a valid device prop', device);
      dispatch(showToast({
        kind: 'error',
        title: 'Fehler',
        caption: 'Gerät konnte nicht ermittelt werden',
      }));
      hideModal();
    }
  }, [deviceID, device, dispatch, hideModal]);

  if (deviceID == null) {
    return null;
  }

  return (
    <Modal
      open={true}
      danger={true}
      size="sm"
      primaryButtonText="Löschen"
      secondaryButtonText="Abbrechen"
      modalHeading={`Soll das Gerät "${deviceLabel}" wirklich gelöscht werden?`}
      onRequestClose={hideModal}
      onRequestSubmit={async () => {
        dispatch(hideForm());
        try {
          setIsLoading(true);
          const result = await deleteDevice(deviceID).unwrap();
          // The backend follows the {status, message} convention even on
          // soft failures (HTTP 200 + status:false). unwrap() only throws
          // for real HTTP errors, so we still have to inspect the body.
          if (result && result.status === false) {
            throw new Error(result.message || 'Das Gerät konnte nicht gelöscht werden');
          }
          dispatch(showToast({
            kind: 'success',
            title: 'Gerät gelöscht',
            caption: 'Das Gerät wurde erfolgreich gelöscht',
          }));
        } catch (err) {
          // Pull the most specific message we can: backend JSON {message},
          // backend plain-text body, then our locally thrown fallback.
          const backendMessage =
            err?.data?.message ||
            (typeof err?.data === 'string' && err.data) ||
            err?.message;
          dispatch(
            showToast({
              kind: 'error',
              title: 'Fehler',
              caption: backendMessage || 'Das Gerät konnte nicht gelöscht werden',
            })
          );
        } finally {
          setIsLoading(false);
          hideModal();
        }
      }}
    >
      <Loading active={isLoading} withOverlay={true} />
    </Modal>
  );
};

export default RemoveDeviceModal;
